import $ from 'jquery'
import _ from 'lodash'

var recaptcha = {
  defaultSiteKey: function defaultSiteKey() {
    return $("meta[name='google-recaptcha-site-key']").attr('content');
  },

  init: function init() {
    if (!this.initialized) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = "https://www.google.com/recaptcha/api.js?onload=recaptchaReady&render=explicit";
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(script, s);
      this.captchaIds = [];
      this.initialized = true;
    }
  },

  ready: function ready() {
    var _this = this;

    this._ready = true;

    if (this.renderQueue) {
      this.renderQueue.forEach(function (renderArgs) {
        _this.captchaIds.push(window.grecaptcha.render.apply(window.grecaptcha, renderArgs));
      });
    }
  },

  render: function render(container, parameters) {
    if (!parameters) {
      parameters = {};
    }

    if (!container) {
      return;
    }

    parameters = _.extend({}, {
      sitekey: this.defaultSiteKey()
    }, parameters);

    if (!parameters.sitekey) {
      parameters.sitekey = this.defaultSiteKey();
    }

    if (this._ready) {
      this.captchaIds.push(window.grecaptcha.render(container, parameters));
    } else {
      if (!this.renderQueue) {
        this.renderQueue = [];
      }

      this.renderQueue.push([container, parameters]);
    }
  },

  reset: function reset() {
    this.captchaIds.forEach(function (captchaId) {
      window.grecaptcha.reset(captchaId);
    });
  }
};

SOPHIA.recaptcha = recaptcha;

window.recaptchaReady = function () {
  recaptcha.ready();
};
